import axios from "axios";
import "./PartnerForm.scss";
import ChannelPartnersForm from "./channelPartnersForm/ChannelPartnersForm";
import VendorPartnersForm from "./vendorPartnersForm/VendorPartnersForm";

import { baseUrl, storePartner } from "../../../utils/apiData";
import SuccessModel from "../../../components/successModel/SuccessModel";
import { useState } from "react";

const PartnerForm = () => {
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState("Form Submited Successfully!");
  const [forUsed, setForUsed] = useState("");
  const [viewMsg, setViewMsg] = useState(false);

  const partnersFormAPi = async (values) => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${storePartner}`, { ...values });
      if (res?.data?.success) {
        setMessage(res?.data?.message);
        setLoader(false);
        setViewMsg(true);
        window.scrollTo(150, 0);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  return (
    <section className="partners_form_wrap">
      <div className="content_wrap">
        <ChannelPartnersForm partnersFormAPi={partnersFormAPi} loader={loader} forUsed={forUsed} setForUsed={setForUsed} viewMsg={viewMsg} />
        <VendorPartnersForm partnersFormAPi={partnersFormAPi} loader={loader} forUsed={forUsed} setForUsed={setForUsed} viewMsg={viewMsg} />
      </div>
      
    </section>
  );
};

export default PartnerForm;
